module.exports = __webpack_public_path__ + "static/media/logo-wildClash.17487b50.png";